import React from 'react';

const Badge = ({ value }) => {
  return <span className="badge">{value}</span>;
};

export default Badge;
